<script lang="ts">
    import { link } from 'svelte-spa-router'
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import { formatDate } from '../../../core/utils/date.util'
    import { t } from '../lib/i18n/t';

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider
    export let update = true

    $: activity = serviceProvider.activityService.getActivityById(dataProvider.activityId)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
    $: group = activity ? serviceProvider.groupService.getGroupById(activity.skupina) : null
</script>

{#if activity}
    <div class="bno-booking-card">
        <div class="bno-booking-card__content-wrap">
            <div class="bno-booking-card__content">

                <h3>
                    {t('summary.shrnutiObjednavky')}
                </h3>
                {#if group}
                    <div class="bno-booking-card__category">
                        <span class="bno-label">{t('summary.misto')}</span>
                        <p>
                            <strong>{group.nazev}</strong>
                        </p>
                    </div>
                {/if}
                <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                    <span class="bno-label">
                        {t('summary.predmetNavstevy')}
                    </span>
                    <p>
                        <strong>{activity.nazev}</strong>
                        {#if update}
                            {#if group}
                                <a href="/{t('page.skupina')}/{group.id}" class="bno-link" use:link>
                                    {t('summary.upravit')}
                                </a>
                            {:else}
                                <a href="/" class="bno-link" use:link>
                                    {t('summary.upravit')}
                                </a>
                            {/if}
                        {/if}
                    </p>
                </div>
                <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                    <span class="bno-label">
                        {t('summary.termin')}
                    </span>
                    <p>
                        <strong>{@html formatDate(dataProvider.date)} {dataProvider.time}</strong>
                        {#if update && activity}
                            <a href="/{t('page.sluzba')}/{activity.id}" class="bno-link" use:link>
                                {t('summary.upravit')}
                            </a>
                        {/if}
                    </p>
                </div>

                {#if !update}
                    <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                        <span class="bno-label">
                            {t('summary.osobniUdaje')}
                        </span>
                        <p>
                            {#if dataProvider.fullName}
                                {t('summary.jmenoPrijmeni')}
                                <br>
                                <strong>{dataProvider.fullName}</strong>
                            {/if}
                        </p>
                        <p>
                            {t('summary.email')}
                            <br>
                            <strong>{dataProvider.email}</strong>
                        </p>
                        <p>
                            {t('summary.telefon')}
                            <br>
                            {#if dataProvider.phone}
                                <strong>{dataProvider.phone}</strong>
                            {/if}
                        </p>
                    </div>

                    {#if dataProvider.isMmbRzSp}
                        <div class="bno-booking-card__category" class:bno-booking-card__category--editable={update}>
                            <span class="bno-label">
                                {t('summary.rzTpVozidla')}
                            </span>
                            <p>
                                <strong>{dataProvider.mmb_rz_tp}</strong>
                            </p>
                        </div>
                    {/if}
                {/if}
            </div>
        </div>
        {#if !update}
            <!--
            <div class="bno-booking-card__footer">
                <a class="bno-link" href="#"><span class="bno-icon bno-icon--print"></span>Tisknout</a>
                <a class="bno-link" href="#"><span class="bno-icon bno-icon--calendar-add"></span>Přidat do
                    kalendáře</a>
            </div>
            -->
        {/if}
    </div>
{/if}
